import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Icon, Ref, Input, Form } from "semantic-ui-react";
import cx from "classnames";

@observer
class EditableLabel extends Component {
  ref = null;

  constructor(props) {
    super(props);

    this.ref = React.createRef();

    this.state = {
      editMode: false,
    };
  }

  onBlur() {
    const { value } = this.props;

    if (value.trim().length > 0) {
      this.setState({ editMode: false });
    }
  }

  enterEditMode() {
    const { editDisabled } = this.props;

    if (editDisabled) {
      return;
    }

    this.setState({ editMode: true }, () => {
      if (!this.ref.current) {
        return;
      }

      // Find the input field and focus on it.
      this.ref.current.getElementsByTagName("input")[0].focus();
    });
  }

  render() {
    const { editDisabled, onChange, value, error, className } = this.props;
    const { editMode } = this.state;

    return (
      <div className={cx("editable-label", className, { editable: !editDisabled })}>
        <Form style={{ display: editMode ? "block" : "none" }}>
          <Ref innerRef={this.ref}>
            <Form.Field
              width={4}
              control={Input}
              placeholder="floor name"
              error={
                error
                  ? {
                      content: error,
                      pointing: "below",
                    }
                  : undefined
              }
              onChange={event => onChange(event.target.value)}
              value={value}
              onBlur={() => this.onBlur()}
            />
          </Ref>
        </Form>
        <div style={{ display: editMode ? "none" : "block" }} onClick={() => this.enterEditMode()}>
          {!editDisabled && <Icon name="pencil" />}
          <span>{value}</span>
        </div>
      </div>
    );
  }
}

EditableLabel.propTypes = {
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  editDisabled: PropTypes.bool,
  className: PropTypes.string,
};

EditableLabel.defaultProps = {
  className: "",
};

export default EditableLabel;
